/**
 * @Author: center
 * @Date: 2021/5/19-4:54 下午
 * @Last Modified by: hongweihu
 * @Last Modified time: 2023-10-23 12:51:57
 */
export const SET_COMPANY_INFO = 'company_info/set_company_info';
